import { Component } from '@angular/core';
import { MotdMessagesService } from '@cl/core/services/motd-messages.service';
import { MotdMessage } from '@cl/shared/models/motd-messages/motd-message.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-motd-message-modal',
    standalone: false,
    templateUrl: './motd-message-modal.component.html',
    styleUrl: './motd-message-modal.component.less',
})
export class MotdMessageModalComponent {
    motdMessage: MotdMessage;

    dismissMotdMessage: boolean = false;

    constructor(private ref: NzModalRef, private motdMessagesService: MotdMessagesService, private messageService: NzMessageService) {}

    async close(): Promise<void> {
        if (this.motdMessage.isDismissible && this.dismissMotdMessage) {
            try {
                await this.motdMessagesService.setMessageDismissed(this.motdMessage);
                this.messageService.success('Paziņojums vairs netiks rādīts!');
                this.ref.close(true);
            } catch (ex) {
                console.error(ex);
                this.ref.destroy();
                if (ex.error?.errors) {
                    ex.error.errors.forEach((error) => {
                        this.messageService.error(error);
                    });
                    return;
                }

                this.messageService.error('Kļūda atzīmējot paziņojumu par nerādāmu');
                return;
            }
        }
        this.ref.destroy(false);
    }
}
